export const icon = {
  size: {
    big: '35px',
    medium: '20px',
    small: '15px',
    x: {
      big: '40px',
      medium: '25px',
      small: '10px',
    },
    xx: {
      big: '50px',
      medium: '30px',
    },
  },
} as const
